import type { QueryProps } from "shared/react";
import type { ListData } from "shared/schema";
import { CardLoader, List } from "shared/react";
import { useQuery } from "../util/db.js";
import { ListCard } from "./ListCard.js";

export function ListList({ query, ...props }: QueryProps<ListData>): React.ReactElement {
	return (
		<List //
			store={useQuery("list", query)}
			mapper={({ id }) => (
				<CardLoader key={id}>
					<ListCard id={id} />
				</CardLoader>
			)}
			{...props}
		/>
	);
}
